"use strict";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
// import {
//   CustomEase
// } from "gsap/CustomEase";
import Vivus from "vivus";
import { slideDown, slideUp } from "slide-anim";
import "pace-progressbar";
Pace.on("done", function () {
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
        duration: 1,
      },
    })
    .to(".loading", { opacity: 0, zIndex: -100 });
  document.querySelector(".pace").classList.toggle("is-load");
});
let mySwiper = new Swiper("#slide02", {
  loop: true,
  autoplay: true,
  pagination: {
    el: ".business-slide-pagination--pc",
    type: "fraction", //fraction タイプ
  },
  slidesPerView: 5,
  spaceBetween: 10,

  navigation: {
    nextEl: ".business-slide-btn--next",
    prevEl: ".business-slide-btn--prev",
  },
  speed: 500,
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".business-slide-pagination--sp",
        type: "bullets",
      },
    },
  },
  on: {
    slideChangeTransitionStart: function () {
      // Slide captions
      var swiper = this;
      var slideTitle = $(swiper.slides[swiper.activeIndex]).attr("data-title");
      var slideName = $(swiper.slides[swiper.activeIndex]).attr("data-name");
      var slideTxt = $(swiper.slides[swiper.activeIndex]).attr("data-txt");
      $(".business-slide-captions").html(function () {
        return (
          "<div class='business-slide-captions__ttl'>" +
          slideTitle +
          "</div>" +
          "<div class='business-slide-captions__name'>" +
          slideName +
          "</div>" +
          "<div class='business-slide-captions__txt'>" +
          slideTxt +
          "</div>"
        );
      });
    },
  },
});

// Slide captions on load
var sizes1 = $(mySwiper.slides[mySwiper.activeIndex]).attr("data-title");
var sizes2 = $(mySwiper.slides[mySwiper.activeIndex]).attr("data-name");
var sizes3 = $(mySwiper.slides[mySwiper.activeIndex]).attr("data-txt");
$(".business-slide-captions").html(function () {
  return (
    "<div class='business-slide-captions__ttl'>" +
    sizes1 +
    "</div>" +
    "<div class='business-slide-captions__name'>" +
    sizes2 +
    "</div>" +
    "<div class='business-slide-captions__txt'>" +
    sizes3 +
    "</div>"
  );
});

const business02txt = new Vivus("businesstxt02", {
  type: "oneByOne",
  start: "manual",
  duration: 60,
  forceRender: false,
  animTimingFunction: Vivus.LINEAR,
});
const linetxt = new Vivus("line-svg", {
  type: "oneByOne",
  start: "manual",
  duration: 10,
  forceRender: false,
  animTimingFunction: Vivus.LINEAR,
});

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.matchMedia({
  // desktop
  "(min-width: 768px)": function () {
    gsap
      .timeline({
        defaults: {
          ease: "power2.out",
          duration: 0.5,
        },
        scrollTrigger: {
          // markers: true,
          trigger: ".business02-lead__txt", // この要素と交差するとイベントが発火
          start: "center center", // ウィンドウのどの位置を発火の基準点にするか
          end: "bottom",
        },
      })
      .to(".business-ttl__item--01", {
        opacity: 1,
        xPercent: 10,
      })
      .to(".business-ttl__item--02", {
        opacity: 1,
        xPercent: -10,
      })
      .to(".business-ttl__item--02", {
        css: {
          filter: "grayscale(0%)",
          "-webkit-filter": "grayscale(0%)",
        },
      })
      .to(".business-ttl__item--bg", {
        opacity: 1,
        scale: 1,
        xPercent: -50,
        yPercent: -50,
      })
      .add(function () {
        business02txt.play();
      }, "-=1")
      .add(function () {
        linetxt.play();
      });
  },
  // mobile
  "(max-width: 767px)": function () {
    gsap
      .timeline({
        defaults: {
          ease: "power2.out",
          duration: 0.5,
        },
        scrollTrigger: {
          // markers: true,
          trigger: ".business-ttl", // この要素と交差するとイベントが発火
          start: "top center", // ウィンドウのどの位置を発火の基準点にするか
          end: "bottom",
        },
      })
      .to(".business-ttl__item--01", { opacity: 1, xPercent: -10 })
      .to(".business-ttl__item--02", { opacity: 1, xPercent: 10 })
      .to(".business-ttl__item--02", {
        css: { filter: "grayscale(0%)", "-webkit-filter": "grayscale(0%)" },
      })
      .to(".business-ttl__item--bg", {
        opacity: 1,
        scale: 1,
        xPercent: -50,
        yPercent: -50,
      })
      .add(function () {
        business02txt.play();
      }, "-=1")
      .add(function () {
        linetxt.play();
      });
  },
});

// closeAcordion();

// function closeAcordion() {
//   // トリガークラス'.js-accordion'を持つ要素を取得
//   const accordionTrigger = document.querySelectorAll(".business02-close");
//   for (let i = 0; i < accordionTrigger.length; i++) {
//     // トリガーを押した時のアクション
//     // let accordionTargetisOpened = false;
//     accordionTrigger[i].addEventListener("click", (e) => {
//       // クリックされた要素（トリガー要素）を取得
//       let currentElement = e.currentTarget;

//       // 同じ親要素を持つ隣接した次の要素'.js-accordion'（展開対象の要素）を取得
//       let accordionTarget = currentElement.parentNode;

//       document.querySelectorAll(".js-close").forEach(target => {
//         target.classList.remove("is-open");
//       });
//       // let parentTtlBtn = currentElement.parentNode.previousElementSibling.lastElementChild;
//       // let parentTtl = currentElement.closest(".js-accordion-wrap");
//       // console.log(parentTtl);
//       //トリガーの'is-active'クラスを削除
//         currentElement.classList.remove("is-active");
//         // parentTtlBtn.classList.remove("is-open");
//         // parentTtl.classList.remove("is-active");
//         slideUp(accordionTarget).then(function () {
//           // accordionTargetisOpened = false;
//         });

//     });
//   }
// }

// トリガークラス'.js-accordion'を持つ要素を取得
const accordionTrigger = $(".business02-close");
// トリガーを押した時のアクション

accordionTrigger.on("click", function () {
  // クリックされた要素（トリガー要素）を取得
  let currentElement = $(this);

  // 同じ親要素を持つ隣接した次の要素'.js-accordion'（展開対象の要素）を取得
  let accordionTargetWrap = $(this).closest(".js-accordion-wrap");
  let accordion = accordionTargetWrap.find(".js-accordion");
  let accordionTarget = accordion.next("div");
  let ttlCmnBtn = accordionTargetWrap.find(".js-close");
  let offSetAccordion = accordionTargetWrap.offset().top - 80;
  //トリガーの'is-active'クラスを削除
  accordion.removeClass("is-active");
  ttlCmnBtn.removeClass("is-open");
  accordionTarget.slideUp();

  setTimeout(function () {
    $(window).scrollTop(offSetAccordion);
    return false;
  }, 100);
});
const YTPlayer = require("yt-player");
const player01 = new YTPlayer("#movie01");
const player02 = new YTPlayer("#movie02");
const player03 = new YTPlayer("#movie03");
const player04 = new YTPlayer("#movie04");
player01.load("eUY3Mk87KIs");
player02.load("ccGY3u7UWJg");
player03.load("RpZQ71Iio6Y");
player04.load("Anm-DeFS-m0");

$(".business02-view-accordion-cont-img__movie--01").on("click", function () {
  player01.play();
  $(this).addClass("is-play");
});
$(".business02-view-accordion-cont-img__movie--02").on("click", function () {
  player02.play();
  $(this).addClass("is-play");
});
$(".business02-view-accordion-cont-img__movie--03").on("click", function () {
  player03.play();
  $(this).addClass("is-play");
});
$(".business02-view-accordion-cont-img__movie--04").on("click", function () {
  player04.play();
  $(this).addClass("is-play");
});
